import * as GroupActions from 'app/main/actions/group-actions.ts';
import { ShowFlash } from 'ng2/shared/flash/store/flash.actions';

module.exports = {
  controller: class AccountMenu {
    static $inject =[
      '$http',
      '$ngRedux',
      '$scope',
      '$rootScope',
      '$state',
      '$stateParams',
      '$translate',
      'LanguageService',
      'PatientAppContextService',
      'RegistrationService',
      'Groups',
      'SecurityService',
    ];

    constructor($http, $ngRedux, $scope, $rootScope, $state, $stateParams, $translate, LanguageService, PatientAppContextService, RegistrationService, Groups, SecurityService) {
      this.$http = $http;
      this.$ngRedux = $ngRedux;
      this.$scope = $scope;
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$translate = $translate;
      this.$stateParams = $stateParams;
      this.LanguageService = LanguageService;
      this.PatientAppContextService = PatientAppContextService;
      this.RegistrationService = RegistrationService;
      this.Groups = Groups;
      this.SecurityService = SecurityService;
    }

    $onInit() {
      this.goToProfile = this.goToProfile.bind(this);
      this.logout = this.logout.bind(this);
      this.isOpen = false;
      this.isFirstItemHover = false;
      this.context = this.PatientAppContextService.context;
      this.bindViewportClick();
    }

    bindViewportClick() {
      this.$scope.$on('viewport:clicked', (event, args) => {
        const target = angular.element(args.jsEvent.target);
        if ((target.parents('.account-menu').length <= 0) && !target.is('.account-menu')) {
          if (this.isOpen) {
            this.toggleDropdown();
          }
        }
      });
    }

    toggleDropdown() {
      this.isOpen = !this.isOpen;
    }

    firstItemHover() {
      this.isFirstItemHover = !this.isFirstItemHover;
    }

    execute(action) {
      if (typeof this[action] === 'function') {
        this.toggleDropdown();
        if (!this.$rootScope.$broadcast('onNavigationStart', {
          callback: this[action],
        }).defaultPrevented) {
          this[action]();
        }
      }
    }

    goToProfile() {
      if (this.$ngRedux.getState().hospitalBooking.isHospitalBooking) {
        this.$state.go('patients.id.update.email');
      } else {
        const id = this.context.patient ? this.context.patient.id : this.context.authenticatedPatient.id;
        this.$state.go('patients.id.update.profile', {
          patientId: id,
        });
      }
    }

    logout() {
      const locale = this.$stateParams.locale || this.$translate.use();

      this.SecurityService.logout().then(() => {
        return this.Groups.get({ id: this.$state.params.groupId, locale }).$promise
        .then((group) => {
          this.$ngRedux.dispatch(GroupActions.setPublicGroup(group));
          this.RegistrationService.initializeStates();
          this.$scope.$emit('application:out');
        });
      }, () => {
        this.$ngRedux.dispatch(new ShowFlash({ name: 'error' }));
      });
    }
  },
  template: `
    <div class="account-menu" ng-class="{ '-open': $ctrl.isOpen }">
      <button class="action" ng-click="$ctrl.toggleDropdown()">
        <span ng-include src="'main/assets/svg/gear.svg'"></span>
      </button>
      <ul class="menu" ng-class="{ '-first': $ctrl.isFirstItemHover }">
        <li class="item" ng-mouseover="$ctrl.firstItemHover()" ng-mouseleave="$ctrl.firstItemHover()">
          <button translate="switch_language" ng-click="$ctrl.LanguageService.switchLanguage()"></button>
        </li>
        <li class="item">
          <button translate="header.manage_profile" ng-click="$ctrl.execute('goToProfile')"></button>
        </li>
        <li class="item">
          <button translate="header.logout" ng-click="$ctrl.execute('logout')"></button>
        </li>
      </ul>
    </div>
    <div class="account-menu -mobile" ng-class="{ '-open': $ctrl.isOpen }">
      <button class="action" ng-click="$ctrl.toggleDropdown()">
        <span ng-include src="'main/assets/svg/gear.svg'"></span>
      </button>
      <ul class="menu" ng-class="{ '-first': $ctrl.isFirstItemHover }">
        <li class="item" ng-mouseover="$ctrl.firstItemHover()" ng-mouseleave="$ctrl.firstItemHover()">
          <button translate="switch_language" ng-click="$ctrl.LanguageService.switchLanguage()"></button>
        </li>
        <li class="item">
          <button translate="header.manage_profile" ng-click="$ctrl.execute('goToProfile')"></button>
        </li>
        <li class="item">
          <button translate="header.logout" ng-click="$ctrl.execute('logout')"></button>
        </li>
      </ul>
    </div>
  `,
};



// WEBPACK FOOTER //
// ./main/components/account-menu.js